import React from 'react';
import { GAMES } from '../../app/consts';
import { IGameId } from 'types/types';
import { remToPx, formatSeconds, extractMs } from '../../utils/utils';
import { RacePlayersProps } from './types';
import { WHITE } from 'styles/colors';
import { AvatarPlaceholder, Current, Next } from './RacePlayers.style';
import SvgIcon from 'components/SvgIcon';
import UserIcon from '../../assets/Icon/user.svg';

const RacePlayers: React.FC<RacePlayersProps> = ({
  race,
  raceIndex,
  current,
  next,
  previous,
  size = 1,
}) => {
  return (
    <div>
      <div className="d-flex flex-column flex-md-row rounded-0 overflow-hidden oswald-regular bg-dark">
        {previous && (
          <Next
            className="text-center"
            style={{
              fontSize: `${size * 1}rem`,
            }}
          >
            <div style={{ transform: `rotate(-90deg)` }}>
              {raceIndex === -2 ? 'Ostatni' : 'Poprzedni'}
            </div>
          </Next>
        )}

        {current && (
          <Current className="text-center" size={2}>
            <div style={{ transform: `rotate(-90deg)` }}>Teraz</div>
          </Current>
        )}
        {next && (
          <Next
            className="text-center"
            style={{
              fontSize: `${size * 1}rem`,
            }}
          >
            <div style={{ transform: `rotate(-90deg)` }}>Następny</div>
          </Next>
        )}
        {/* Race data */}
        <div
          className="d-flex flex-column text-uppercase justify-content-center position-relative"
          style={{
            backgroundColor: current ? `rgba(222, 38, 116, 0.2)` : '',
            color: WHITE,
            minWidth: `${size * 6}rem`,
          }}
        >
          <div
            className="text-center"
            style={{
              fontSize: `${size * 1}rem`,
              padding: `${size * 0.25}rem ${size * 0.5}rem`,
              zIndex: 1,
            }}
          >
            {raceIndex === -2 ? '' : `Wyścig ${raceIndex + 1}`}
          </div>
          <div
            className="d-flex align-intems-center justify-content-start justify-content-md-start text-center position-absolute bottom-0 end-0 w-100 h-100 overflow-hiden"
            style={{ opacity: `0.20`, zIndex: 0 }}
          >
            <img
              src={GAMES[race?.game.id as IGameId]?.['image']}
              width={remToPx(size * 4)}
              height={remToPx(size * 4)}
              style={{
                width: `${size * 9}rem`,
                height: `${size * 9}rem`,
                objectFit: `cover`,
                marginTop: `-${size * 2}rem`,
              }}
            />
          </div>
          <div
            className="text-center oswald-light"
            style={{
              fontSize: `${size * 1}rem`,
              padding: `${size * 0.25}rem ${size * 0.5}rem`,
              zIndex: 1,
            }}
          >
            {GAMES[race?.game.id as IGameId]?.name}
          </div>
        </div>
        {/* Runs container */}
        <div
          className="d-flex flex-row flex-fill bg-dark"
          style={{ gap: `0px`, zIndex: 5 }}
        >
          {race?.runs.map((run, idx) => (
            // Run
            <div
              key={run.id}
              className="d-flex flex-row justify-content-center justify-content-md-between w-50 align-items-center text-light"
              style={{
                backgroundColor: current ? `rgba(222, 38, 116, 0.2)` : '',
                borderLeft: `1px solid rgba(255,255,255,0.15)`,
                fontSize: `${size * 1.5}rem`,
                padding: `${size * 0.5}rem`,
              }}
            >
              <div
                className="d-flex flex-column flex-md-row  align-items-center"
                style={{
                  columnGap: `${size * 0.5}rem`,
                  rowGap: `${size * 0.5}rem`,
                }}
              >
                <div
                  className="rounded"
                  style={{
                    backgroundColor: `rgba(255, 255, 255, 0.10)`,
                    width: remToPx(size * 4),
                    height: remToPx(size * 4),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {run.player.avatar ? (
                    <img
                      src={run.player.avatar || ''}
                      width={remToPx(size * 4)}
                      height={remToPx(size * 4)}
                      className="rounded"
                    />
                  ) : (
                    <AvatarPlaceholder className="d-flex justify-content-center align-items-center rounded">
                      <SvgIcon
                        src={UserIcon}
                        width={`${size * 3}rem`}
                        height={`${size * 3}rem`}
                      />
                    </AvatarPlaceholder>
                  )}
                </div>

                <div
                  className="d-flex flex-column lh-1"
                  style={{ gap: `1rem` }}
                >
                  <div className="text-uppercase">{run.player.extra?.name}</div>

                  {(run.status === 'completed' ||
                    run.status === 'incomplete') && (
                    <div>
                      {formatSeconds(run.duration)}
                      <span
                        style={{
                          color: `rgba(255,255,255,0.3)`,
                          fontSize: `0.75em`,
                        }}
                      >
                        .{extractMs(run.duration || 0)}
                      </span>
                      {run.player.extra?.isBest && (
                        <span className="ps-3">🏆</span>
                      )}
                      {run.status === 'incomplete' && (
                        <span className="ps-3">🌓</span>
                      )}
                    </div>
                  )}
                  {run.status === 'disqualified' && (
                    <div>
                      <span className="">
                        {run.status === 'disqualified' && '⚠️'}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RacePlayers;
